export type Testimonial = {
  quote: string
  name: string
  country: string
  photo: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'Before, I was improvising everything — estimates, warranties and even my pricing. Now I have a clear process and my customers take me much more seriously.',
    name: 'Carlos R.',
    country: 'Colombia',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/ca319037-610e-4827-bdf7-5b0166b111df.jpg',
  },
  {
    quote:
      'System #6 alone is worth much more than what I paid. Having all the professional forms ready saved me weeks of work.',
    name: 'Miguel G.',
    country: 'Mexico',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/3976e2f9-79d0-4a75-92c9-a6efb6bf0bae.jpg',
  },
  {
    quote:
      "I finally realized how much money I was losing on almost every repair because I wasn't calculating my real costs. The Real Profit System completely changed the way I price my work.",
    name: 'José L.',
    country: 'Venezuela',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/346bf6f9-58f0-4421-a774-b6c92687929d.jpg',
  },
]

export const faqs: { question: string; answer: string[] }[] = [
  {
    question: 'Do I need business or accounting experience?',
    answer: [
      'No.',
      'Technical System PRO 360™ was created specifically for appliance repair technicians who want to organize and professionalize their business without needing an accounting or business degree.',
    ],
  },
  {
    question: 'Does it work in the United States?',
    answer: [
      'Yes.',
      'The systems are designed around universal business principles for appliance repair technicians. You can customize names, prices, business information and documents to fit your local market.',
      'Important: legal, tax and warranty requirements can vary by location, so customize any legal documents according to your local regulations.',
    ],
  },
  {
    question: 'How will I receive the material?',
    answer: [
      'Immediately after completing your purchase, you’ll receive instructions to access and download your digital materials.',
      'No physical products are shipped.',
    ],
  },
  {
    question: 'Is this a one-time payment?',
    answer: [
      'Yes.',
      '$27 is a one-time payment.',
      'There are no monthly subscriptions or recurring charges.',
    ],
  },
  {
    question: 'Will I have lifetime access?',
    answer: [
      'Yes.',
      'Once you purchase the system, your access is yours to keep.',
    ],
  },
  {
    question: 'Are the files editable?',
    answer: [
      'Yes.',
      'The included templates and documents are designed to be customized with your business name, contact information, prices and other relevant details.',
    ],
  },
]

export const buyerNotifications: { name: string; country: string }[] = [
  { name: 'Andrés M.', country: 'Argentina' },
  { name: 'Luis F.', country: 'Mexico' },
  { name: 'Jorge P.', country: 'Colombia' },
  { name: 'Ricardo S.', country: 'Chile' },
  { name: 'Manuel T.', country: 'Peru' },
  { name: 'Diego H.', country: 'Uruguay' },
  { name: 'Rafael O.', country: 'Spain' },
  { name: 'Héctor V.', country: 'Ecuador' },
  { name: 'Iván C.', country: 'Venezuela' },
  { name: 'Marcos D.', country: 'Panama' },
  { name: 'Sergio A.', country: 'Guatemala' },
  { name: 'Pablo N.', country: 'Dominican Republic' },
]
